import type { NotificationSettingsItem } from "../types/notification.types"

export const CHANNEL_KEYS: (keyof NotificationSettingsItem)[] = [
  "email",
  "in_app",
  "phone",
  "desktop"
]

// Channels a row carries only when the server sends them: WhatsApp on every
// row of a server that has it, SMS only where the row says `sms_available`.
export const OPTIONAL_CHANNEL_KEYS: (keyof NotificationSettingsItem)[] = [
  "whatsapp",
  "sms"
]

// Finance alerts must keep at least one delivery channel enabled; see the
// enabledCount invariant in NotificationSettingsForm.
export const CRITICAL_GROUPS = ["PAYMENTS", "INVOICES"]
